let HostName = {
  API_URL: process.env.REACT_APP_API_URL,
  Docker: 'http://localhost:3232',
  dev: 'http://localhost:3232'
}

export default HostName
